const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const SensorPeripheral = require('../common/sensor-peripheral');
const { default: bleUtils } = require('../../util/ble');
const { BLE_CONFIG } = require('../../util/bleCharac');


/**
 * 数字环境光传感器
 * 
 * @readonly
 */
const DIVECE_OPT = {
    type: 'sensor'
};

// const BLE_CONFIG = {
//     prefix: 'LM',
//     SERVICE_UUID: 0x01FF,
//     lightIntensity: 0x0210,
// }
/**
 * Manage communication with a Arduino esp32 peripheral over a Scratch Link client socket.
 */
class YMDLGT extends SensorPeripheral {
    /**
     * Construct a Arduino communication object.
     * @param {Runtime} runtime - the Scratch runtime
     * @param {string} deviceId - the id of the extension
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     */
    constructor(runtime, deviceId, originalDeviceId) {
        super(runtime, deviceId, originalDeviceId, null, BLE_CONFIG, DIVECE_OPT);
    }
}

class ScratchYMDLGTDevice {

    /**
     * @return {string} - the ID of this deivce.
     */
    get DEVICE_ID() {
        return 'yiLight';
    }

    /**
     * Construct a set of Arduino blocks.
     * @param {Runtime} runtime - the Scratch runtime.
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     */
    constructor(runtime, originalDeviceId) {
        /**
         * The Scratch runtime.
         * @type {Runtime}
         */
        this.runtime = runtime;

        
        this._peripheral = new YMDLGT(this.runtime, this.DEVICE_ID, originalDeviceId);
        this.bleUtils = new bleUtils();
          //  添加：是否正在连接或已连接
          this._connectionLock = false;
          this._connectionPromise = null;
    }

    getInfo() {
        return [{
            id: 'yiLight',
            name: formatMessage({
                id: 'YMDLGT.categoryName',
                default: 'YM DLGT',
                description: 'Label for the yi Light extension category'
            }),
            color1: "#536DFE",
            color2: "#4A64F7",
            color3: "#405BF0",
            blocks: [
                {
                    opcode: 'connect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMDLGT.ble.connect',
                        default: 'connect to YM-DLGT-[DEVICE_NAME]',
                        description: 'Connect to YM-DLGT'
                    }),
                    arguments: {
                        DEVICE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: ' ',
                        }
                    }
                },
                {
                    opcode: 'disConnect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMDLGT.ble.disconnect',
                        default: 'disconnect from YM-DLGT',
                        description: 'Disconnect from YM-DLGT'
                    })
                },
                {
                    opcode: 'getBrightness',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMDLGT.getBrightness',
                        default: 'get brightness',
                        description: 'Get the brightness of the light'
                    })
                },
            ],
            menus: {}
        }];
    }


    /**
     * Connect to YM-K3 device
     * @param {object} args - { DEVICE_NAME }
     */
async connect(args) {
    const deviceName = 'YM-DLGT-' + (args.DEVICE_NAME?.trim() || "");

    // 🔒 如果已经在连接流程中，直接返回已有 promise
    if (this._connectionPromise) {
        console.log(`Connection already in progress or completed. Skipping duplicate connect for ${deviceName}`);
        return await this._connectionPromise;
    }

    // 🔒 创建一个连接 promise 并缓存，防止后续调用再次触发 requestDevice
    this._connectionPromise = this._doConnect(deviceName).catch(err => {
        console.error('Connection failed:', err);
        // 失败后允许重试（可选）：若想禁止重试，则不清理 _connectionPromise
        // this._connectionPromise = null;
    });

    return await this._connectionPromise;
}
 /**
     * 实际执行连接逻辑（仅执行一次）
     */
 async _doConnect(deviceName) {
    // 再次检查是否已连接（避免 race condition）
    const connected = await this.isConnected();
    if (connected) {
        console.log('Already connected. Skip connection.');
        return true;
    }

    console.log(`Connecting to YM K3 device: ${deviceName}`);

    try {
        // ✅ 此处调用 bleUtils.connect，假设它封装了 requestDevice
        await this.bleUtils.connect(deviceName, BLE_CONFIG.SERVICE_UUID);
        console.log(`Connected to device: ${deviceName}`);
        return true;
    } catch (error) {
        // 清理状态，允许用户手动重试
        this._connectionPromise = null;
        throw error; // 抛出错误以便上层处理
    }
}

    async isConnected() {
        console.log('Checking if device is connected');
        return this.bleUtils.device !== null && this.bleUtils.device.gatt.connected;
    }

    async disConnect() {
        console.log('Disconnecting from YM-DLGT device');
        if (this.bleUtils.device) {
            try {
                await this.bleUtils.disConnect(this.bleUtils.device);
                console.log('Disconnected from device');
                // 🔒 断开后释放连接锁，允许重新连接
                this._connectionPromise = null;
            } catch (error) {
                console.error('Failed to disconnect:', error);
            }
        }
    }

    async getBrightness() {
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.lightIntensity);
                const dataView = await this.bleUtils.readCharacteristic(characteristic);
                if (dataView?.buffer instanceof ArrayBuffer) {
                    //解析数据
                    let buffer = Array.from(new Uint8Array(dataView.buffer));
                    const hexStr = buffer.map(_ => {
                        return this.bleUtils.int2Hex(_);
                    }).reverse().join("");
                    const brightness = parseInt(hexStr, 16);
                    console.log(`Brightness: ${brightness}`);
                    // // 设置精灵坐标
                    // this.runtime.targets.forEach(target => {
                    //     if (target.isSprite) {
                    //         // 设置x和y坐标
                    //         target.setXY(brightness / 100, 0);
                    //     }
                    // });
                    return brightness;
                }
            } catch (error) {
                console.error('Failed to set brightness:', error);
            }
        }
    }
}

module.exports = ScratchYMDLGTDevice;